import { render, staticRenderFns } from "./distribution1.vue?vue&type=template&id=7308d3c9&scoped=true"
import script from "./distribution1.vue?vue&type=script&lang=js"
export * from "./distribution1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7308d3c9",
  null
  
)

export default component.exports